/**
 * Device Storage API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface BatteryTypeDto { 
    backUpBatteryUnits?: Array<BatteryTypeDto.BackUpBatteryUnitsEnum>;
    backupCapacity?: number;
    batteryShape?: BatteryTypeDto.BatteryShapeEnum;
    batterySize?: BatteryTypeDto.BatterySizeEnum;
    cameraBatteryUnits?: Array<BatteryTypeDto.CameraBatteryUnitsEnum>;
    cameraCapacity?: number;
    customerName?: string;
    dropOffBatteryUnits?: Array<BatteryTypeDto.DropOffBatteryUnitsEnum>;
    dropOffCapacity?: number;
    fullName?: string;
    housingTypeId?: string;
    id?: string;
    isDeprecated?: boolean;
    isFix?: boolean;
    lithiumContent?: number;
    mainBatteryUnits?: Array<BatteryTypeDto.MainBatteryUnitsEnum>;
    mainCapacity?: number;
    namePrefix?: string;
    possibleDeviceTypeIds?: Array<string>;
    version?: number;
    weight?: number;
}
export namespace BatteryTypeDto {
    export const BackUpBatteryUnitsEnum = {
        Lsh20: 'LSH20',
        Lsh14: 'LSH14',
        Ls17500: 'LS17500',
        Ls14500: 'LS14500',
        Ls14250: 'LS14250',
        Lp113040: 'LP113040',
        Lp903040: 'LP903040',
        HlcPulsesPlus: 'HLC_PULSES_PLUS',
        Lincm14500: 'LINCM14500',
        InfinioLtc: 'INFINIO_LTC',
        Inr18650: 'INR_18650'
    } as const;
    export type BackUpBatteryUnitsEnum = typeof BackUpBatteryUnitsEnum[keyof typeof BackUpBatteryUnitsEnum];
    export const BatteryShapeEnum = {
        Square: 'SQUARE',
        Curved: 'CURVED'
    } as const;
    export type BatteryShapeEnum = typeof BatteryShapeEnum[keyof typeof BatteryShapeEnum];
    export const BatterySizeEnum = {
        _1C: '1C',
        _1D: '1D',
        _2D: '2D',
        _3D: '3D',
        _4D: '4D',
        _5D: '5D',
        _6D: '6D',
        _7D: '7D',
        _15D: '15D',
        _26C: '26C',
        _1A: '1A',
        _1Aa: '1AA',
        _25Aa: '2.5AA',
        _05Aa: '0.5AA',
        Lp14: 'LP14',
        Mp25: 'MP25',
        _2Sx: '2SX'
    } as const;
    export type BatterySizeEnum = typeof BatterySizeEnum[keyof typeof BatterySizeEnum];
    export const CameraBatteryUnitsEnum = {
        Lsh20: 'LSH20',
        Lsh14: 'LSH14',
        Ls17500: 'LS17500',
        Ls14500: 'LS14500',
        Ls14250: 'LS14250',
        Lp113040: 'LP113040',
        Lp903040: 'LP903040',
        HlcPulsesPlus: 'HLC_PULSES_PLUS',
        Lincm14500: 'LINCM14500',
        InfinioLtc: 'INFINIO_LTC',
        Inr18650: 'INR_18650'
    } as const;
    export type CameraBatteryUnitsEnum = typeof CameraBatteryUnitsEnum[keyof typeof CameraBatteryUnitsEnum];
    export const DropOffBatteryUnitsEnum = {
        Lsh20: 'LSH20',
        Lsh14: 'LSH14',
        Ls17500: 'LS17500',
        Ls14500: 'LS14500',
        Ls14250: 'LS14250',
        Lp113040: 'LP113040',
        Lp903040: 'LP903040',
        HlcPulsesPlus: 'HLC_PULSES_PLUS',
        Lincm14500: 'LINCM14500',
        InfinioLtc: 'INFINIO_LTC',
        Inr18650: 'INR_18650'
    } as const;
    export type DropOffBatteryUnitsEnum = typeof DropOffBatteryUnitsEnum[keyof typeof DropOffBatteryUnitsEnum];
    export const MainBatteryUnitsEnum = {
        Lsh20: 'LSH20',
        Lsh14: 'LSH14',
        Ls17500: 'LS17500',
        Ls14500: 'LS14500',
        Ls14250: 'LS14250',
        Lp113040: 'LP113040',
        Lp903040: 'LP903040',
        HlcPulsesPlus: 'HLC_PULSES_PLUS',
        Lincm14500: 'LINCM14500',
        InfinioLtc: 'INFINIO_LTC',
        Inr18650: 'INR_18650'
    } as const;
    export type MainBatteryUnitsEnum = typeof MainBatteryUnitsEnum[keyof typeof MainBatteryUnitsEnum];
}


export type BackUpBatteryUnitsEnum = typeof BatteryTypeDto.BackUpBatteryUnitsEnum[keyof typeof BatteryTypeDto.BackUpBatteryUnitsEnum];
export type BatteryShapeEnum = typeof BatteryTypeDto.BatteryShapeEnum[keyof typeof BatteryTypeDto.BatteryShapeEnum];
export type BatterySizeEnum = typeof BatteryTypeDto.BatterySizeEnum[keyof typeof BatteryTypeDto.BatterySizeEnum];
export type CameraBatteryUnitsEnum = typeof BatteryTypeDto.CameraBatteryUnitsEnum[keyof typeof BatteryTypeDto.CameraBatteryUnitsEnum];
export type DropOffBatteryUnitsEnum = typeof BatteryTypeDto.DropOffBatteryUnitsEnum[keyof typeof BatteryTypeDto.DropOffBatteryUnitsEnum];
export type MainBatteryUnitsEnum = typeof BatteryTypeDto.MainBatteryUnitsEnum[keyof typeof BatteryTypeDto.MainBatteryUnitsEnum];
